import { exists, SystemCode, SystemCodeFromJSON } from '@/api'
import { SearchType } from '@/types'

export interface ConditionReserve {
  id: number
  searchType: SearchType
  notHandlingType: SystemCode[]
  notCollectionStatus: SystemCode[]
  userReservationLimit: number
  bibliographyReservationLimit: number
  sameReservationEnabled: ReservationEnabled
  ownLendingReservationEnabled: ReservationEnabled
  receiptDateMethod: ReceiptDateMethod
  receiptDateAutomaticEnabled: ReceiptDateAutomaticEnabled
  receiptDays: number
  revision: number
}

export const ReservationEnabled = {
  Disabled: '0',
  Enabled: '1',
  Message: '2'
} as const
export type ReservationEnabled = typeof ReservationEnabled[keyof typeof ReservationEnabled]

export const ReceiptDateAutomaticEnabled = {
  Disabled: '0',
  Enabled: '1'
} as const
export type ReceiptDateAutomaticEnabled = typeof ReceiptDateAutomaticEnabled[keyof typeof ReceiptDateAutomaticEnabled]

export const ReceiptDateMethod = {
  NotConsiderClose: 'N',
  CloseNextOpen: 'Y',
  CalculateOpenDays: 'K'
} as const
export type ReceiptDateMethod = typeof ReceiptDateMethod[keyof typeof ReceiptDateMethod]

export function ConditionReserveFromJSON(json: any): ConditionReserve {
  return {
    id: exists(json, 'id') ? json.id : 0,
    searchType: exists(json, 'search_type') ? json.search_type : '',
    notHandlingType: exists(json, 'not_handling_type')
      ? json.not_handling_type.map(SystemCodeFromJSON)
      : [],
    notCollectionStatus: exists(json, 'not_collection_status')
      ? json.not_collection_status.map(SystemCodeFromJSON)
      : [],
    userReservationLimit: exists(json, 'user_reservation_limit')
      ? json.user_reservation_limit
      : 0,
    bibliographyReservationLimit: exists(json, 'bibliography_reservation_limit')
      ? json.bibliography_reservation_limit
      : 0,
    sameReservationEnabled: exists(json, 'same_reservation_enabled')
      ? json.same_reservation_enabled
      : ReservationEnabled.Disabled,
    ownLendingReservationEnabled: exists(
      json,
      'own_lending_reservation_enabled'
    )
      ? json.own_lending_reservation_enabled
      : ReservationEnabled.Disabled,
    receiptDateMethod: exists(json, 'receipt_date_method')
      ? json.receipt_date_method
      : ReceiptDateMethod.CloseNextOpen,
    receiptDateAutomaticEnabled: exists(json, 'receipt_date_automatic_enabled')
      ? json.receipt_date_automatic_enabled
      : ReceiptDateAutomaticEnabled.Disabled,
    receiptDays: exists(json, 'receipt_days') ? json.receipt_days : 0,
    revision: exists(json, 'revision') ? json.revision : 0
  }
}
